Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById('calculation-tool')) {
        Layout.components.calculationtool = new Vue({
            el: document.getElementById("calculation-tool"),
            store,
            data: function () {
                return {

                    selectedProduct: 0,
                    chosenGrams: 0,             // Kies het aantal gram
                    chosenGramsDefault: true,
                    productsPerBox: 0,

                    iceMixType: 'liquid',

                    gramPerMix: 0,

                    pricePerBox: 0,             // Prijs per doos (24)
                    pricePerBoxWaffles: 0,      // Prijs per doos voor wafels (30.1)
                    mixPerGram: 0,              // Mix per gram
                    costPriceMix: 0,            // Kostprijs mix
                    pricePerWaffle: 0,          // Prijs per wafel,
                    costPriceIcecream: 0,       // Kostprijs ijsje
                    sellingPrice: 0,            // Verkoopprijs
                    tax: 0.09,                  // 9% btw,
                    costsDivider: 2,            // Verkoopprijs delen,
                    costsDividerPowderMix: 5.6,
                    costsMultipler: 10,         // Verkoopprijs vermenigvuldigen,

                    kiloPerBoxMixLiquid: 10,    // 1000g
                    kiloPerBoxMixPowder: 10,    // 1000g
                    gramBoxMix: 10000,          // gram doos mix
                    numberOfIceCreams: 10000,   // aantal ijsjes

                    advicePrice: 0,             // Adviesverkoopprijs

                    showForm: true,

                    formSendingError: false,
                    formApproved: false,

                    formValues: {
                        name: '',
                        email: '',
                        telephone: '',
                        company: ''
                    },
                    formErrors: {
                        name: [true, ''],
                        email: [false, ''],
                        telephone: [false, ''],
                        company: [false, '']
                    }

                }
            },
            mixins: [],
            computed: {},
            mounted() {
                if(this.$el.dataset && this.$el.dataset.userLoggedIn && this.$el.dataset.userLoggedIn === '1') {
                    this.showForm = false;
                }

                if(this.$el.dataset && this.$el.dataset.gramPerMix) {
                    this.gramPerMix = parseFloat(this.$el.dataset.gramPerMix);
                }

                if(this.$el.dataset && this.$el.dataset.initialProductGram) {
                    this.chosenGrams = parseFloat(this.$el.dataset.initialProductGram);
                }

                if(this.$el.dataset && this.$el.dataset.initialProductsPerBox) {
                    this.productsPerBox = parseFloat(this.$el.dataset.initialProductsPerBox);
                }

                if(this.$el.dataset && this.$el.dataset.costsDivider) {
                    this.costsDivider = parseFloat(this.$el.dataset.costsDivider);
                }

                if(this.$el.dataset && this.$el.dataset.costsMultiplier) {
                    this.costsMultiplier = parseFloat(this.$el.dataset.costsMultiplier);
                }

                if(this.$el.dataset && this.$el.dataset.powderPricePerBoxRatio) {
                    this.costsDividerPowderMix = parseFloat(this.$el.dataset.powderPricePerBoxRatio);
                }

                if(this.$el.dataset && this.$el.dataset.vat) {
                    this.tax = parseFloat(this.$el.dataset.vat / 100);
                }

            },
            methods: {
                submit() {
                    this.checkAndSubmitForm();
                },
                checkAndSubmitForm() {
                    this.formApproved = true

                    if (this.formValues.name === '' || this.formValues.name.length <= 2) {
                        this.formErrors.name = [true, 'Uw naam is verplicht en moet minstens twee tekens bevatten']
                        this.formApproved = false
                    } else {
                        this.formErrors.name = [false, '']
                    }

                    if (this.formValues.company === '' || this.formValues.company.length <= 2) {
                        this.formErrors.company = [true, 'Een bedrijfsnaam is verplicht en moet minstens twee tekens bevatten']
                        this.formApproved = false
                    } else {
                        this.formErrors.name = [false, '']
                    }

                    if (this.formValues.email === '' || this.formValues.email.length <= 7 || !this.formValues.email.includes("@") || !this.formValues.email.includes(".")) {
                        this.formErrors.email = [true, 'Het bovenstaande emailadres klopt niet. Dit veld is verplicht.']
                        this.formApproved = false
                    } else {
                        this.formErrors.email = [false, '']
                    }

                    if (this.formApproved === true) {
                        this.postFormEntry();
                    }

                },
                postFormEntry() {
                    this.formSending = true;
                    let post = JSON.stringify(this.formValues);

                    const url = "/wp-json/coolbreak/v1/calculation-tool-form"
                    let xhr = new XMLHttpRequest()

                    xhr.open('POST', url, true)
                    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
                    xhr.send(post);

                    xhr.onload = () => {
                        if (xhr.status === 201 || xhr.status === 200) {
                            Vue.set(this, 'formSending', false);
                            Vue.set(this, 'showForm', false);
                        } else {
                            // TODO fout afhandeling van volledige formulier als er tijd over is...
                            Vue.set(this, 'formSendingError', true);
                        }
                    }
                },

                setChosenGramsDefault(val) {
                    this.chosenGramsDefault = val;
                },

                setProduct(index, grams, productsPerBox, defaultGramsValue) {
                    this.chosenGramsDefault = defaultGramsValue;
                    this.selectedProduct = parseFloat(index);
                    this.chosenGrams = parseFloat(grams);
                    this.productsPerBox = parseFloat(productsPerBox);
                },

                calculatePrices() {
                    this.calculateMixPerGram();
                    this.calculateCostPrice();
                    this.calculatePricePerWaffle();
                    this.calculateCostPriceIcecream();
                    this.calculateSellingPriceIcecream();
                },

                calculateMixPerGram() {
                    if(this.iceMixType === 'powder') {
                        this.mixPerGram = ((this.pricePerBox / this.costsDividerPowderMix)  / this.gramPerMix);
                    } else if(this.iceMixType === 'liquid'){
                        this.mixPerGram = (this.pricePerBox / this.gramPerMix);
                    }
                },

                calculateCostPrice() {
                    if(this.iceMixType === 'liquid') {
                        this.numberOfIceCreams = ((this.kiloPerBoxMixLiquid * 1000) / this.chosenGrams);
                        this.costPriceMix = (this.pricePerBox / this.numberOfIceCreams);
                    } else {
                        this.numberOfIceCreams = ((this.kiloPerBoxMixPowder * 3250) / this.chosenGrams);
                        this.costPriceMix = (this.pricePerBox / this.numberOfIceCreams);
                    }
                },

                calculateCostPriceIcecream() {
                    this.costPriceIcecream = this.costPriceMix + this.pricePerWaffle;
                },

                calculatePricePerWaffle(){
                    this.pricePerWaffle = parseFloat(this.pricePerBoxWaffles) / parseFloat(this.productsPerBox);

                    if(isNaN(this.pricePerWaffle) || !isFinite(this.pricePerWaffle)) {
                        this.pricePerWaffle = 0;
                    }

                },

                calculateSellingPriceIcecream(){
                    this.sellingPrice = (this.costPriceIcecream / this.costsDivider) * this.costsMultipler;
                },

                isNumber: function(evt, setDefaultChosenGram = false) {

                    if (setDefaultChosenGram) {
                        this.setChosenGramsDefault(false);
                    }

                    evt = (evt) ? evt : window.event;
                    const charCode = (evt.which) ? evt.which : evt.keyCode;
                    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                        evt.preventDefault();
                    } else {
                        return true;
                    }
                },

                customToFixed(number, decimals) {
                    if(typeof Number(number) === 'number') {
                        return Number(number).toFixed(decimals);
                    } else {
                        return number
                    }
                }

            },
            watch: {
                selectedProduct(val) {
                    this.calculatePrices();
                },
                chosenGrams() {
                    this.calculatePrices();
                },
                iceMixType() {
                    this.calculatePrices();
                },
                pricePerBox() {
                    this.calculatePrices();
                },
                costPriceMix() {
                    this.calculatePrices();
                },
                pricePerWaffle() {
                    this.calculatePrices();
                },
                pricePerBoxWaffles() {
                    this.calculatePrices();
                },
                kiloPerBoxMixLiquid() {
                    this.calculatePrices();
                },
                kiloPerBoxMixPowder() {
                    this.calculatePrices();
                }
            },
            created() {
            },
            destroyed() {
            }
        });
    }
});

